import { InputNumber, Select } from 'antd'
import { Form } from 'antd'
import { FC } from 'react'
import { requiredInputNumberRules } from '../../../../../../../../constants/forms/validation/rules'

interface LengthProps {}

const Length: FC<LengthProps> = () => {
    const name = 'quantity'
    const selectAfter = (
        <Form.Item name={'unit'} noStyle>
            <Select>
                <Select.Option value='km'>км</Select.Option>
                <Select.Option value='m2'>м2</Select.Option>
            </Select>
        </Form.Item>
    )
    return (
        <Form.Item name={name} label={'Кол-во'} rules={requiredInputNumberRules}>
            <InputNumber style={{ width: '100%' }} addonAfter={selectAfter} />
        </Form.Item>
    )
}

export default Length
